// extracted by mini-css-extract-plugin
module.exports = {"container":"header_container__2x4P2","wrapper":"header_wrapper__2-oR4","placeholder":"header_placeholder__2LGvd","logo":"header_logo__1k1gR","headerLogo":"header_headerLogo__3lond","slogan":"header_slogan__35fwE"};
    if(module.hot) {
      // 1785568560394
      var cssReload = require("!../../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  